import { useEffect } from "react";
import { useConfig } from "../../context/ConfigContext";

export interface SeoProps {
    title?: string;
    tituloCompleto?: boolean;
    author?: string;
    description?: string;
    keywords?: string;
    canonicalUrl?: string;
    robots?: string;

    //openGraph tag
    ogTitle?: string;
    ogDescription?: string;
    ogImage?: string;
    ogSiteName?: string;

    //Twitter tag
    twitterCard?: string;
    twitterSite?: string;
    twitterImage?: string;
    twitterTitle?: string;
    twitterDescription?: string;

    marcaBlanca?: string;
}

const useSEOConfig = (props: SeoProps) => {
    const { config } = useConfig();

    useEffect(() => {
            if (props.title !== undefined || props.tituloCompleto !== undefined) {
                document.title = props.tituloCompleto
                    ? (props.title ?? 'Segurarse')
                    : `${config.prefix ?? 'Segurarse'} | ${props.title ?? 'Segurarse'}`;
            }

        const updateMetaTag = (name: string, content?: string) => {
            if (content) {
                let meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
                if (!meta) {
                    meta = document.createElement('meta');
                    meta.name = name;
                    document.head.appendChild(meta);
                }
                meta.content = content;
            }
        };

        const updatePropertyMetaTag = (property: string, content?: string) => {
            if (content !== undefined) {
                let meta = document.querySelector(`meta[property="${property}"]`);
                if (!meta) {
                    meta = document.createElement('meta');
                    meta.setAttribute('property', property);
                    document.head.appendChild(meta);
                }
                meta.setAttribute('content', content);
            }
        };

        // Dominio base según país, siempre SIN www
        const baseDomain = config.pais === "UY"
            ? "https://segurarse.com.uy"
            : "https://segurarse.com.ar";

        // Imagen OG por defecto según país. Si la página pasa ogImage explícito, se respeta.
        const ogImage = props.ogImage ?? `${baseDomain}/ContentS/img/metadatos_banner.jpg`;

        updateMetaTag('author', props.author);
        updateMetaTag('description', props.description);
        updateMetaTag('keywords', props.keywords);

        updatePropertyMetaTag('og:title', props.ogTitle);
        updatePropertyMetaTag('og:description', props.ogDescription);
        updatePropertyMetaTag('og:image', ogImage);
        updatePropertyMetaTag('og:url', baseDomain + window.location.pathname);
        updatePropertyMetaTag('og:type', 'website');

        updateMetaTag('twitter:card', props.twitterCard);
        updateMetaTag('twitter:title', props.twitterTitle || props.ogTitle);
        updateMetaTag('twitter:description', props.twitterDescription || props.ogDescription);
        updateMetaTag('twitter:image', props.twitterImage || ogImage);
        updateMetaTag('twitter:site', props.twitterSite || props.ogSiteName);


        // Actualizar el tag robots
        if (props.robots) {
            updateMetaTag('robots', props.robots);
        }

        // Actualizar el canonical URL:
        // - Si la página pasa canonicalUrl explícito, se respeta.
        // - Si no, se arma un canonical autorreferencial (sin www) a partir del pathname.
        let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
        if (!link) {
            link = document.createElement('link');
            link.rel = 'canonical';
            document.head.appendChild(link);
        }
        link.href = props.canonicalUrl ?? (baseDomain + window.location.pathname);
    }, [props]);
};

export default useSEOConfig;